export default __webpack_public_path__ + "static/media/gyninewlogo.6d3e1777.svg";